export const headers = [
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Cadastrado Em', field: 'created_at', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
